// -------------------------------------------------    -------------------------
// #126 - ACTIVITY COMPLETION
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var ModalDisplay = require('../modal');
var modalDisplay = new ModalDisplay();

module.exports = function (options) {
    var context = options.context;

    function init() {
        var activeForm = context.find('form');
        var activeButton = context.find('[data-binding="activity-completion-button"]');
        var activeButtonLoadingText = activeButton.data('loading-text');

        context.each(function () {
            var externalExists = false;
            var thisContext = $(this);
            if (!externalExists) {
                externalExists = true;
                modalDisplay.externalModal(thisContext, thisContext.find('[data-binding="modal"]'), 'reward');
            }

            if (window.location.hash === '#social-reward-modal') {
                thisContext.find('.info').trigger('click');
            }
        });

        activeForm.on('submit', function (e) {
            activeButton.addClass('disabled');
            activeButton.find('.button__text').text(activeButtonLoadingText);

            $.ajax({
                data: $(this).serialize() + '&' + activeButton.attr('name') + '=',
                type: $(this).attr('method'),
                url: $(this).attr('action'),
                success: function success(data) {
                    var $data = $(data);

                    /// Only the activity-completion partial is being returned so entire context can be replaced with the received data
                    context.html($data);

                    /// Reinitialise to rebind events
                    init();
                }
            });

            e.preventDefault();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activity-completion.js
// module id = 204
// module chunks = 0